// UI chrome-hide driver. Owns the list of DOM IDs that make up the on-screen
// UI (panels, perf container, colorbar, help) and toggles their visibility
// in response to 'ui:chrome:hide' / 'ui:chrome:restore' intents — used by
// render/screenshot.ts so non-UI code never reaches into the DOM.

import { INTENTS } from '../store/intents';
import type { Store } from '../store/store';
import type { State } from '../store/schema';

const HIDE_DOM_IDS = [
    'controls-rail', 'controls-flyout', 'topbar-menu', 'perf-container',
    'colorbar-container', 'task-indicator', 'help-panel', 'console-panel',
];

let savedDisplays: Map<HTMLElement, string> | null = null;

function hideChrome(): void {
    if (savedDisplays) return;
    savedDisplays = new Map();
    HIDE_DOM_IDS.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.style && el.style.display !== 'none') {
            savedDisplays!.set(el, el.style.display);
            el.style.display = 'none';
        }
    });
}

function restoreChrome(): void {
    if (!savedDisplays) return;
    for (const [el, prev] of savedDisplays.entries()) {
        try { el.style.display = prev || ''; } catch { /* swallow */ }
    }
    savedDisplays = null;
}

export function installChromeDriver(store: Store<State>): () => void {
    const offHide = store.onIntent(INTENTS.UI_CHROME_HIDE, hideChrome);
    const offRestore = store.onIntent(INTENTS.UI_CHROME_RESTORE, restoreChrome);
    return () => { offHide(); offRestore(); restoreChrome(); };
}
